import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Badge as RmwcBadge} from '@rmwc/badge'
import '@rmwc/badge/styles'

export const StyledRmwcBadge = styled(RmwcBadge)`
  &&& {
    font-family: 'Open Sans', sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    letter-spacing: inherit;
    text-decoration: inherit;
    text-transform: inherit;
    font-size: 12px;
    font-weight: 700;
    line-height: 16.37px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--mdc-theme-on-secondary5);
    background: var(--mdc-theme-secondary5);
  }
`

const Badge = ({children, ...otherProps}) => <StyledRmwcBadge {...otherProps}>{children}</StyledRmwcBadge>

Badge.propTypes = {
  children: PropTypes.any
}

export {Badge}
